const WEIGHTS = [400, 500, 600, 700];

/** Reforço via FontFace API — @font-face principal está em public/index.html */
export function loadLudiFonts() {
  if (typeof document === 'undefined' || !document.fonts?.load) {
    return Promise.resolve();
  }

  return Promise.all(
    WEIGHTS.map((weight) =>
      document.fonts
        .load(`${weight} 16px "Space Grotesk"`)
        .catch(() => {
          const face = new FontFace(
            'Space Grotesk',
            `url(/fonts/space-grotesk/SpaceGrotesk-${weight}.ttf)`,
            { weight: String(weight), style: 'normal', display: 'swap' }
          );
          return face.load().then((loaded) => document.fonts.add(loaded));
        })
    )
  ).catch((err) => {
    console.warn('[Ludi] font load fallback failed', err);
  });
}
